import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";

export const Route = createFileRoute("/es/terms-of-use")({
  head: () => ({
    meta: [
      { title: "Términos de Uso — Picamini.online" },
      {
        name: "description",
        content: "Términos y condiciones de uso del sitio web Picamini.online y sus herramientas gratuitas.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/es/terminos-de-uso" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/terms-of-use" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/terminos-de-uso" },
    ],
  }),
  component: EsTermsPage,
});

function EsTermsPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="es" />

      <main className="flex-1 py-12 mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 space-y-6">
        <h1 className="text-3xl font-extrabold text-foreground">Términos de Uso</h1>
        <p className="text-sm text-muted-foreground">Última actualización: Septiembre 2026</p>

        <div className="surface-card p-6 sm:p-8 rounded-2xl bg-card border space-y-4 text-sm sm:text-base text-muted-foreground leading-relaxed">
          <h2 className="text-xl font-bold text-foreground">1. Aceptación de los Términos</h2>
          <p>
            Al acceder y utilizar Picamini.online, aceptas estar sujeto a estos términos y condiciones de servicio de forma ilimitada.
          </p>

          <h2 className="text-xl font-bold text-foreground">2. Uso Gratuito e Imparcial</h2>
          <p>
            Nuestras herramientas se ofrecen de forma gratuita para uso personal, educativo y comercial. Queda prohibido el mal uso o intento de interrupción del servicio mediante ataques cibernéticos.
          </p>

          <h2 className="text-xl font-bold text-foreground">3. Propiedad Intelectual</h2>
          <p>
            El diseño, interfaz y marca de Picamini.online son propiedad exclusiva. Los usuarios conservan la propiedad total de cualquier archivo o texto procesado a través del sitio.
          </p>

          <h2 className="text-xl font-bold text-foreground">4. Modificaciones</h2>
          <p>
            Nos reservamos el derecho de actualizar o modificar estas herramientas y términos en cualquier momento para mejorar el servicio.
          </p>
        </div>
      </main>

      <SiteFooter lang="es" />
    </div>
  );
}
